import { useTranslation } from 'react-i18next';
import { Typography, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import RegulationAcceptance, {
  RegulationAcceptanceProps
} from 'pages/account/Register/pages/Main/steps/components/RegulationAcceptance';

import { IconInfo } from '../Icon';

const AcceptRegulationsWithInfoView = <T,>({
  ...formikProps
}: RegulationAcceptanceProps<T>) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Grid pt={3.5}>
      <Grid flexDirection="row" display="flex" alignItems="center" pb={2}>
        <Grid pr={3}>
          <Typography color={`${theme.customPalette.cobalt.primary}`}>
            <IconInfo sx={{ fontSize: 24 }} />
          </Typography>
        </Grid>
        <Grid>
          <Typography
            variant="subtitle1"
            color={`${theme.customPalette.cobalt.primary}`}
          >
            {t('FIRST_LOGIN_REGULATION_ACCEPTANCE')}
          </Typography>
        </Grid>
      </Grid>
      <RegulationAcceptance {...formikProps} />
    </Grid>
  );
};

export default AcceptRegulationsWithInfoView;
